import React, {useState, useEffect,useRef} from 'react';
import {Link} from 'react-router-dom';
import {getMyPostsById} from '../../../services/servicesGetMyPostsById';
import {getMyPosts} from '../../../services/servicesGetMyPosts';
import MenuPreview from '../menuPreview';
import RodapePreview from '../rodapePreview';
import {MyBtn} from '../stylePreview';
import {IconAiOutlineArrowUp,IconAiOutlineArrowLeft,IconAiOutlineArrowRight} from '../stylePreview';
import {DivTituloDoPost,DivImagemDoPost,DivTextoDoPost,DivFooter,SpanNavegacao,} from './stylePreviewPostId';
import {URLIMG} from '../../../helpers/constantes';

export default function PreviewPostId(){

    let URL = window.location.href.split('/');
    const [idDoPost, setIdDoPost] = useState(URL[7]);
    const [idDoUsuario] = useState('342338727');
    const [post, setPost] = useState({titulo:'',texto:'',image:'',id:'',data:''});
    const [postsNavegacao, setPostsNavegacao] = useState()
    const [anteriorPosterior, setAnteriorPosterior] = useState([]);
    const [mostraBotao, setMostraBotao] = useState(false);
    const scrollRef = useRef()

    async function carregaPost(post_id){
        const result = await getMyPostsById(post_id);
        if (result != null)
        setPost({
                ...post,
                titulo:result[0].PostTitle,
                texto:encodeURIComponent(result[0].PostText).split(/%0A/ug),
                image:URLIMG + result[0].Image1,
                id:result[0].Id,
                data:result[0].Date,
            })
    }

    async function carregaTodosPosts(user_id){
        const result = await getMyPosts(user_id);
        setPostsNavegacao(result);
    }

     function pegaAnteriorPosterior(){

         let arrayInterno = [];
        if(typeof(postsNavegacao)!== 'undefined' && postsNavegacao.length > 0){
            postsNavegacao.map((item,index,array)=>{
                if(item.Id.toString() === idDoPost.toString()){
                    if(array[index-1] && array[index+1])
                    arrayInterno.push(
                        {Id:array[index-1].Id,titulo:array[index-1].PostTitle,},
                        {Id:array[index+1].Id,titulo:array[index+1].PostTitle}
                    )
                    else if(array[index+1]) //post liberado mais recente
                    arrayInterno.push({Id:array[index+1].Id,titulo:array[index+1].PostTitle,position:'direita'})
                    else
                    arrayInterno.push({Id:array[index-1].Id,titulo:array[index-1].PostTitle,position:'esquerda'})

                }
                return 0;
            });
            setAnteriorPosterior(arrayInterno);
        }
        return arrayInterno;
    }
    function GoToTop(){
        scrollRef.current.scrollTop = 0;
    }


    function MostraBotao(){
        if(scrollRef.current.scrollTop > 200){
            setMostraBotao(true);
        }else if(scrollRef.current.scrollTop < 200){
            setMostraBotao(false);
        }

    }

    useEffect(()=>{
        carregaPost(idDoPost);
    },[idDoPost])

    useEffect(() => {
        carregaTodosPosts(idDoUsuario);
    }, []);

    useEffect(()=>{

        if (typeof(postsNavegacao)!=='undefined')
        pegaAnteriorPosterior()
    },[postsNavegacao,idDoPost])


    return(<div ref={scrollRef} onScroll={MostraBotao} style={{overflow:'auto', background:'#fff',height:'100vh',scrollBehavior:'smooth'}}>
                <MyBtn onClick={GoToTop} display={mostraBotao?'block':'none'}>
                    <IconAiOutlineArrowUp />
                </MyBtn>
                <MenuPreview/>
                <div style={{textAlign:'center',paddingBottom:'40px',marginTop:'40px'}}>
                    <DivTituloDoPost>
                        {post.titulo}
                    </DivTituloDoPost>
                    <DivImagemDoPost>
                        <img alt='' style={{width:'700px',borderRadius:'3px'}} src={post.image}/>
                    </DivImagemDoPost>
                    <div style={{textAlign:'-webkit-center',width:'100%'}}>
                        <DivTextoDoPost>
                            {post.texto === ''?" "
                            :
                                post.texto.map((item,index)=>{
                                    return(<p key={index}>{decodeURIComponent(item)}<br/></p>)
                                })
                            }
                        </DivTextoDoPost>
                        {anteriorPosterior.length > 1 ?
                            (<DivFooter>
                                <div style={{textAlign:'start'}}>
                                    <div style={{width:'fit-content',marginBottom:'20px'}}>
                                        <Link onClick={()=>{setIdDoPost(anteriorPosterior[0].Id); GoToTop()}} to={`/preview/post_id/${anteriorPosterior[0].Id}`} >
                                            <IconAiOutlineArrowLeft />
                                            <SpanNavegacao><b>Anterior</b></SpanNavegacao>
                                        </Link>
                                    </div>
                                        <div style={{fontSize:'20px',width:'50%'}}>
                                            <i>{anteriorPosterior[0].titulo}</i>
                                        </div>
                                </div>
                                    <div style={{textAlign:'-webkit-right'}}>
                                        <div style={{width:'fit-content',marginBottom:'20px'}}>
                                            <Link onClick={()=>{setIdDoPost(anteriorPosterior[1].Id); GoToTop()}} to ={`/preview/post_id/${anteriorPosterior[1].Id}`} >
                                                <SpanNavegacao><b>Proximo</b></SpanNavegacao>
                                                <IconAiOutlineArrowRight />
                                            </Link>
                                        </div>
                                        <div style={{fontSize:'20px',textAlign:'start',width:'50%'}}>
                                            <i>{anteriorPosterior[1].titulo}</i>
                                        </div>
                                    </div>
                            </DivFooter>)
                        : anteriorPosterior.length > 0 ?
                            <>{anteriorPosterior[0].position === 'direita' ?
                                <div style={{textAlign:'-webkit-right',padding:'0 80px',margin:'50px 0'}}>
                                    <div style={{width:'fit-content',marginBottom:'20px'}}>
                                        <Link onClick={()=>{setIdDoPost(anteriorPosterior[0].Id); GoToTop()}} to={`/preview/post_id/${anteriorPosterior[0].Id}`} >
                                            <div>
                                                <SpanNavegacao>
                                                    <b>Proximo</b>
                                                </SpanNavegacao>
                                                <IconAiOutlineArrowRight />
                                            </div>
                                        </Link>
                                    </div>
                                    <div style={{fontSize:'20px',width:'50%'}}>
                                    <i>{anteriorPosterior[0].titulo}</i>
                                    </div>
                                </div>
                            :
                                <div style={{textAlign:'start',padding:'0 80px',margin:'50px 0'}}>
                                    <div style={{width:'fit-content',marginBottom:'20px'}}>
                                        <Link onClick={()=>{setIdDoPost(anteriorPosterior[0].Id); GoToTop()}} to={`/preview/post_id/${anteriorPosterior[0].Id}`} >
                                            <div style={{textAlign:'-webkit-right'}}>
                                                <IconAiOutlineArrowLeft />
                                                <SpanNavegacao>
                                                    <b>Anterior</b>
                                                </SpanNavegacao>
                                            </div>
                                        </Link>
                                    </div>
                                    <div style={{fontSize:'20px',width:'50%'}}>
                                    <i>{anteriorPosterior[0].titulo}</i>
                                    </div>
                                </div>
                            }</>
                        :''}
                    </div>
                </div>
            <RodapePreview/>
            </div>

    )
}
